<template>
  <Login data-fn-location="login"/>
</template>

<script>
import Login from '../components/templates/Login'
import translate from '@/language'

export default {
  metaInfo: {
    title: `${translate('', 'login')} - Finnomena`
  },
  components: {
    Login
  }
}
</script>
